import { useState } from "react"
import { useQueryState } from "./useQueryState"

export function useAppPaginationBase({ limit, offset, setOffset }) {
  const [total, setTotal] = useState(0)
  return {
    limit,
    total,
    offset,
    setOffset,
    setTotal,
  }
}

export function useAppPagination(limit: number) {
  const [offset, setOffset] = useState(0)
  return useAppPaginationBase({ limit, offset, setOffset })
}

export function useAppPaginationQuery(limit: number) {
  const [offset = 0, setOffset] = useQueryState<number | undefined>("off")
  return useAppPaginationBase({ limit, offset, setOffset })
}
